import React, { useState } from 'react';
import { Box } from '@mui/material';
import useRUMView from 'common-datadog/useRUMView';
import useApplication from '../../resources/applications/read';
import useRepair from '../../resources/repairs/read';
import Screen from '../Screen';
import ButtonPrimary from '../ButtonPrimary';
import InstallmentRoadSideAssistance from '../InstallmentRoadSideAssistance';
import useForm from './useForm';
import LoanDetails from './LoanDetails';
import LoanPackageRadioGroup from './LoanPackageRadioGroup';
import RSABanner from './RSABanner';

const InstallmentSelectLoanPackage = () => {
  useRUMView('installment-select-loan-package');
  const { data: application } = useApplication();
  const [showRSA, setShowRSA] = useState(false);
  useRepair(); // Call here so Suspense loading screen doesn't render on radio btn click
  const roadsideLoan = application.attributes.loan_options[0].ancillary_loans[0];
  const regularLoan = application.attributes.loan_options[0].regular_loans[0];
  const loans = {
    [roadsideLoan?.id]: roadsideLoan,
    [regularLoan.id]: regularLoan,
  };

  const {
    handleSubmit,
    isSubmitting,
    control,
    watch,
    setValue,
  } = useForm();

  const loanPackageId = watch('loanPackageId');

  return (
    <Screen
      header="Select your loan package."
      subheader="Once you have selected a loan package that works for your budget, click “Save Terms & Continue.”"
    >
      <InstallmentRoadSideAssistance
        setValue={setValue}
        showRSA={showRSA}
        setShowRSA={setShowRSA}
      />
      {application.attributes['roadside_assistance_offered?'] && (
        <RSABanner setShowRSA={setShowRSA} />
      )}
      <Box
        component="form"
        onSubmit={handleSubmit}
      >
        <LoanPackageRadioGroup control={control} />
        { loanPackageId && <LoanDetails loanPackage={loans[loanPackageId]} /> }
        <ButtonPrimary isLoading={isSubmitting}>
          Save Terms & Continue
        </ButtonPrimary>
      </Box>
    </Screen>
  );
};

export default InstallmentSelectLoanPackage;
